import { Outlet } from 'react-router';

import { useScrollToHash } from '@/hooks/useScrollToHash';

import { StickerLayer } from './Circuits';
import { Footer } from './Footer';
import { Header } from './Header';

export function Layout() {
  useScrollToHash();

  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#contenu"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:rounded-sm focus:bg-ciel focus:px-4 focus:py-2 focus:text-encre"
      >
        Aller au contenu
      </a>

      <Header />

      {/* Les sections passent au-dessus de la couche de stickers. */}
      <main id="contenu" className="relative flex-1 *:not-first:relative *:not-first:z-[1]">
        <StickerLayer />
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
